import React, { Component, Suspense } from 'react';
import '../assets/css/styles.css';

class App extends Component {
  render() {
    return (
      <Suspense fallback='Carregando'>
        <div id='root'>
          <meta charSet='utf-8'></meta>
          {this.props.children}
        </div>
      </Suspense>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/app.js